if (typeof window !== "undefined" && window.document) {
  // Your script here...
  function test() {
    // console.log("Test Event")
  }
  test()
}
